import { Component, OnInit } from '@angular/core';
import {FieldService} from '../field/field.service';

@Component({
    selector: 'dmp-field-selector-mode',
    templateUrl: './field-selector-mode.component.html',
    styleUrls: ['./field-selector-mode.component.scss'],
    standalone: false
})
export class FieldSelectorModeComponent implements OnInit {


    constructor(private fieldService: FieldService) {
    }

  ngOnInit(): void {
  }

    doClick() {
        this.fieldService.mode = this.fieldService.mode === 'EDIT' ? 'READ' : 'EDIT';
    }
}
